import { ExternalLink } from "@/components/ExternalLink";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { createEnum } from "@/lib/utils/createEnum";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type C5StaticDatum = {
  id: number;
  name?: string;
  isin?: string;
  code?: string;
  ticker?: string;
  currency?: string;
  asset_class_1?: string;
  asset_class_2?: string;
  has_transactions?: boolean;
  has_time_series?: boolean;
};
const c5StaticDatumFields = createEnum<C5StaticDatum>();

export const porfolios_columns: ColumnDef<C5StaticDatum>[] = [
  { accessorKey: c5StaticDatumFields.id, header: "Id" },
  { accessorKey: c5StaticDatumFields.name, header: "Nom" },
  { accessorKey: c5StaticDatumFields.isin, header: "ISIN" },
  { accessorKey: c5StaticDatumFields.code, header: "Code" },
  { accessorKey: c5StaticDatumFields.ticker, header: "Ticker" },
  { accessorKey: c5StaticDatumFields.currency, header: "Devise" },
  { accessorKey: "asset_class_1", header: "Classe d'actifs" },
  {
    accessorKey: c5StaticDatumFields.asset_class_2,
    header: "Sous-classe d'actifs",
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const hasTransactions = row.original.has_transactions;
      const hasTimeSeries = row.original.has_time_series;

      return (
        <div className="flex gap-11 justify-end">
          <div className="flex gap-3">
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.C5}/${Tables.C5_TRANSACTIONS}`,
              )}
              queryParams={{
                c5_static_data_id_equal: row.getValue(c5StaticDatumFields.id),
              }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Transactions
            </ExternalLink>
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.C5}/${Tables.C5_TIME_SERIES}`,
              )}
              queryParams={{
                c5_static_data_id_equal: row.getValue(c5StaticDatumFields.id),
              }}
              className={`text-xs ${
                !hasTimeSeries ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Valorisations
            </ExternalLink>
          </div>
          <Link
            href={`${window.location.pathname}/${row.getValue(c5StaticDatumFields.id)}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
